var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3333 18.6693H43.6666C44.5871 18.6693 45.3333 19.4155 45.3333 20.3359V43.6693C45.3333 44.5897 44.5871 45.3359 43.6666 45.3359H20.3333C19.4128 45.3359 18.6666 44.5897 18.6666 43.6693V20.3359C18.6666 19.4155 19.4128 18.6693 20.3333 18.6693ZM15.3333 20.3359C15.3333 17.5745 17.5718 15.3359 20.3333 15.3359H43.6666C46.428 15.3359 48.6666 17.5745 48.6666 20.3359V43.6693C48.6666 46.4307 46.428 48.6693 43.6666 48.6693H20.3333C17.5718 48.6693 15.3333 46.4307 15.3333 43.6693V20.3359ZM31.9999 32.0026C27.3975 32.0026 23.6666 27.5255 23.6666 22.0026H26.9999C26.9999 26.2794 29.7817 28.6693 31.9999 28.6693C34.2181 28.6693 36.9999 26.2794 36.9999 22.0026H40.3333C40.3333 27.5255 36.6023 32.0026 31.9999 32.0026Z",
    fill: "#FCFCFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2A80BD",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#246FB6",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#329BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#2E8FC3",
    stopOpacity: 0.30816
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductos);
export default __webpack_public_path__ + "static/media/productos.f425e4d184502c9b3e1cee0e256cf6aa.svg";
export { ForwardRef as ReactComponent };